import React, { useState, useContext } from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { EPCContext } from '../../contexts/epcContext';
import {
  convertSubsToPrefs, getSubscriptions, updateEmailPreferences
} from '../../common/sharedFunctions';
import { TextModal } from '../TextModal/TextModal';
import { EMAIL_INFORMATION_SECTIONS } from '../../constants/informationPageConstants';
import { BannerContext, BannerProvider } from '../../contexts/BannerContext';
import ErrorBoundary from '../../contexts/ErrorBoundary';
import PreferenceCard from '../PreferenceCard/PreferenceCard';
import { emailTableHeaders } from '../tableData';
import { SignUpModal } from '../SignUpModal/SignUpModal';
import constants from '../../constants/constants';
import { determineMessage } from '../../utils/general';

export function Preferences() {

  const {
    email, setEmail,
    surveyEmailTableData, setSurveyEmailTableData, isMobile
  } = useContext(EPCContext);
  const { openErrorAlert, openSuccessAlert, hideBanners } = React.useContext(BannerContext);

  const [toggleEmailInformationPage, setToggleEmailInformationPage] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [toggleSignUp, setSignUp] = useState(false);

  const handleContinue = (emailInput) => {
    updateEmailPreferences({
      emailAddress: emailInput,
      subscriptions: selectedItems,
      table: surveyEmailTableData,
      callback: (response) => {

        if (email !== emailInput) {
          setEmail(emailInput);
        }
        setSurveyEmailTableData(convertSubsToPrefs(surveyEmailTableData, getSubscriptions(response)));
        openSuccessAlert(determineMessage(selectedItems, surveyEmailTableData), emailInput);
        setSelectedItems([]);
      },
      err: (err) => {
        openErrorAlert();
      }
    });
  };

  const handleToggleEmailInformationPage = () => {
    setToggleEmailInformationPage(!toggleEmailInformationPage);
  };

  const handleSaveChanges = () => {
    if (selectedItems.length > 0) {
      hideBanners();
      if (!email) {
        setSignUp(true);
      } else {
        handleContinue(email);
      }
    }
  };

  return (
    <div className="sui-grid sui-gap-4">
      <Typography variant="h2" weight="display">SURVEY EMAILS</Typography>
      <Typography variant="body-base" height="none">
        If you don&apos;t want to provide customer feedback, you can unsubscribe from our survey emails.
      </Typography>

      <div className="sui-grid" data-testid="survey-sub-table">
        <PreferenceCard
          headerColumn={emailTableHeaders}
          tableData={surveyEmailTableData}
          name="surveys"
          hasIdentifier={!!email}
          setTableData={setSurveyEmailTableData}
          isMobile={isMobile}
          setSelectedItems={setSelectedItems}
        />
        <div className="sui-grid sui-grid-cols-8">
          <div className="hidden sm:sui-col-span-4 md:sui-col-span-5" />
          <div className="sui-col-span-8 sm:sui-col-span-4 md:sui-col-span-3 sui-grid sui-gap-y-4">
            <Button
              aria-label="updateSurveyPreferenceButton"
              fullWidth
              onClick={handleSaveChanges}
              data-testid="updateSurveyPreferenceButton"
            >
              Save Changes
            </Button>
          </div>
        </div>
      </div>
      {toggleSignUp && (
        <SignUpModal
          setSignUp={setSignUp}
          type={constants.EMAIL}
          handleSignUpCallBack={handleContinue}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          setTableData={setSurveyEmailTableData}
          tableData={surveyEmailTableData}
        />
      )}

      {toggleEmailInformationPage && (
        <TextModal
          onModalClose={handleToggleEmailInformationPage}
          sections={EMAIL_INFORMATION_SECTIONS}
        />
      )}
    </div>
  );
}

export function SurveyEmailPreferences() {
  return (
    <ErrorBoundary>
      <BannerProvider>
        <Preferences />
      </BannerProvider>
    </ErrorBoundary>
  );
}
